import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('etech_admin_token') || '';
const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

// Auto-logout on 401 for admin endpoints
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const url = error.config?.url || '';
      if (url.includes('/admin/') && !url.endsWith('/admin/login')) {
        localStorage.removeItem('etech_admin_token');
        if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin') {
          window.location.href = '/admin';
        }
      }
    }
    return Promise.reject(error);
  }
);

export const api = {
  createLead: (data) => axios.post(`${API}/leads`, data).then((r) => r.data),
  listCaseStudies: () => axios.get(`${API}/case-studies`).then((r) => r.data),
  getCaseStudy: (slug) => axios.get(`${API}/case-studies/${slug}`).then((r) => r.data),
  adminLogin: (password) => axios.post(`${API}/admin/login`, { password }).then((r) => r.data),
  adminLogout: () => axios.post(`${API}/admin/logout`, {}, { headers: authHeaders() }).then((r) => r.data),
  listLeads: () => axios.get(`${API}/admin/leads`, { headers: authHeaders() }).then((r) => r.data),
  adminListCS: () => axios.get(`${API}/admin/case-studies`, { headers: authHeaders() }).then((r) => r.data),
  createCS: (data) => axios.post(`${API}/admin/case-studies`, data, { headers: authHeaders() }).then((r) => r.data),
  updateCS: (slug, data) => axios.put(`${API}/admin/case-studies/${slug}`, data, { headers: authHeaders() }).then((r) => r.data),
  deleteCS: (slug) => axios.delete(`${API}/admin/case-studies/${slug}`, { headers: authHeaders() }).then((r) => r.data),
  deleteCSById: (id) => axios.delete(`${API}/admin/case-studies-by-id/${id}`, { headers: authHeaders() }).then((r) => r.data),
  unreadCount: () => axios.get(`${API}/admin/leads/unread-count`, { headers: authHeaders() }).then((r) => r.data),
  markLeadsRead: () => axios.post(`${API}/admin/leads/mark-read`, {}, { headers: authHeaders() }).then((r) => r.data),
  exportLeadsUrl: () => `${API}/admin/leads/export.csv?token=${encodeURIComponent(getToken())}`,
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/admin/upload`, fd, { headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  backendUrl: process.env.REACT_APP_BACKEND_URL,
};

export const resolveImage = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};
